<template>
  <modal :title="$t(titledia)" :visible.sync="isShowDialog" width="600px">
    <el-form ref="form" :model="dioForm" :rules="isMode?rules:{}" label-width="140px">
      <el-form-item :label="$t('public.task')" prop="taskName">
        <el-input
          v-if="isMode"
          v-model.trim="dioForm.taskName"
          style="width: 250px;"
          :placeholder="$t('integration.please_enter_a_task')"
        />
        <span v-else>{{ detailFormObj.taskName }}</span>
        <i
          v-show="optate !== 'add'"
          :class="!isMode ? 'el-icon-edit' : 'el-icon-back'"
          style="color:var(--primary-color);float: right;cursor: pointer;"
          @click="changeEdit"
        ></i>
      </el-form-item>
      <el-form-item
        :label="$t('public.table_scope')"
        prop="scopeId"
        v-if="$store.state.type === 3 || $store.state.type === 2"
      >
        <el-select v-model="dioForm.scopeId" style="width: 250px" v-if="isMode">
          <el-option
            v-for="item in customerArray"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span v-else>{{ customerFn(detailFormObj.scopeId) }}</span>
      </el-form-item>
      <el-form-item :label="$t('public.status')" prop="status">
        <el-select v-model="dioForm.status" style="width: 250px" v-if="isMode">
          <el-option
            v-for="item in statusArray"
            :key="item.code"
            :label="$t('task.'+item.content)"
            :value="item.code"
          ></el-option>
        </el-select>
        <span v-else>{{ statusFn(detailFormObj.status) }}</span>
      </el-form-item>
      <el-form-item :label="$t('public.check_item')" prop="taskContentId">
        <el-select v-model="dioForm.taskContentId" style="width: 250px" v-if="isMode">
          <el-option
            v-for="item in contentArray"
            :key="item.id"
            :label="$t(item.i18nKey)"
            :value="item.id"
          ></el-option>
        </el-select>
        <span v-else>{{ contentFn(detailFormObj.taskContentId) }}</span>
      </el-form-item>
      <el-form-item :label="$t('public.interval')" prop="interval">
        <el-input
          v-if="isMode"
          v-model.trim="dioForm.interval"
          style="width: 150px;margin-right: 15px;"
          :placeholder="$t('integration.please_enter_the_interval')"
        />
        <el-select
          v-if="isMode"
          v-model="dioForm.intervalUnit"
          style="width: 85px"
          @change="changeUnit"
        >
          <el-option
            v-for="item in unitArray"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
        <span v-else>{{ intervalFn(detailFormObj.interval, detailFormObj.intervalUnit) }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
      <el-button type="primary" @click="handleSave" v-show="isMode">{{ $t('public.btn_confirm') }}</el-button>
    </div>
  </modal>
</template>

<script>
import { taskAdd, taskUpdate } from '@/api/modules/task.js'
export default {
  props: [
    'isShow',
    'title',
    'customerArray',
    'statusArray',
    'contentArray',
    'unitArray',
    'isEdit',
    'optate',
    'detailObj'
  ],
  computed: {
    isShowDialog: {
      get: function() {
        return this.isShow
      },
      set: function(val) {
        this.$emit('update:isShow', val) //可以优化成model  或者minx
      }
    },
    isMode: {
      get: function() {
        return this.isEdit
      },
      set: function(val) {
        this.$emit('update:isEdit', val) //可以优化成model  或者minx
      }
    },
    rules() {
      let checkInt = (rules, value, callback) => {
        let reg = /^\+?[1-9]\d*$/

        if (Number(value) >= 10000) {
          callback($t('integration.interval_length_is_within_4'))
        } else if (!reg.test(value)) {
          callback($t('integration.please_enter_an_integer_greater_than_0'))
        } else {
          callback()
        }
      }
      return {
        taskName: [
          { required: true, message: $t('integration.task_cannot_be_empty'), trigger: 'blur' },
          {
            max: 30,
            message: $t('public.len_max_30'),
            trigger: 'blur'
          }
        ],
        interval: [
          { required: true, message: $t('integration.interval_cannot_be_empty'), trigger: 'blur' },
          {
            required: true,
            validator: checkInt,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    detailObj(newVal) {
      newVal.status = String(newVal.status)
      newVal.intervalUnit = String(newVal.intervalUnit)
      this.dioForm = { ...newVal }
      this.detailFormObj = { ...newVal }
    },
    title(newVal) {
      this.titledia = newVal
    }
  },
  data() {
    return {
      titledia: '',
      dioForm: {
        taskName: '',
        scopeId: '',
        status: '0',
        taskContentId: 1,
        interval: '',
        intervalUnit: '0'
      },
      detailFormObj: {}
    }
  },
  mounted() {},
  methods: {
    changeEdit() {
      this.isMode = !this.isMode
      this.titledia = !this.isMode
        ? `${$t('public.edit')} [${this.dioForm.taskName}]`
        : `${this.dioForm.taskName} ${$t('public.details')}`
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    customerFn(id) {
      let str = ''

      for (let item of this.customerArray) {
        if (item.id === id) {
          str = item.name
          break
        }
      }
      return str
    },
    statusFn(id) {
      let str = ''

      for (let item of this.statusArray) {
        if (item.code === String(id)) {
          str = item.name
          break
        }
      }
      return str
    },
    contentFn(id) {
      let str = ''
      for (let item of this.contentArray) {
        if (item.id === id) {
          str = this.$t(item.i18nKey)
          break
        }
      }
      return str
    },

    intervalFn(value, unit) {
      let str = unit === '0' ? $t('public.minute') : unit === '1' ? $t('integration.hour') : $t('integration.day')
      return value + str
    },
    changeUnit() {
      this.$refs['form'].validateField('interval')
    },
    clearValidate() {
      if (this.$refs.form) {
        this.dioForm.intervalUnit = '0'
        this.dioForm.status = '0'
        this.dioForm.taskContentId = 1
        this.$refs.form.resetFields()
      }
    },
    async justify() {
      try {
        return await this.$refs['form'].validate()
      } catch (error) {
        return false
      }
    },
    async handleSave() {
      let falg = await this.justify()
      if (!falg) return
      let httpUrl = taskAdd
      if (this.optate === 'detail') {
        httpUrl = taskUpdate
        delete this.dioForm.updateTime
        delete this.dioForm.createTime
        delete this.dioForm.createUser
        delete this.dioForm.updateUser
      }
      httpUrl(this.dioForm).then(({ result }) => {
        if (result === 200) {
          this.$message.success(this.$t('public.tip_oper_succ'))
          this.$parent.getListFn()
          this.isShowDialog = false
        } else if (result === 404) {
          this.$message.error($t('integration.name_cannot_be_empty'))
        } else if (result === 405) {
          this.$message.error($t('integration.task_content_cannot_be_empty'))
        } else if (result === 406) {
          this.$message.error($t('integration.execution_interval_cannot_be_empty'))
        } else if (result === 400) {
          this.$message.error(this.$t('public.tip_oper_fail'))
        } else {
          this.$message.error($t('integration.task_failed'))
        }
      })
    }
  }
}
</script>

<style>
</style>